type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LoggerConfig {
    enabled: boolean;
    level: LogLevel;
}

const LOG_LEVELS: Record<LogLevel, number> = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};

const config: LoggerConfig = {
    enabled: process.env.NODE_ENV !== 'production',
    level: 'debug',
};

function shouldLog(level: LogLevel): boolean {
    return config.enabled && LOG_LEVELS[level] >= LOG_LEVELS[config.level];
}

function formatMessage(prefix: string, args: unknown[]): unknown[] {
    if (typeof args[0] === 'string') {
        return [`[${prefix}] ${args[0]}`, ...args.slice(1)];
    }
    return [`[${prefix}]`, ...args];
}

export const logger = {
    debug: (...args: unknown[]): void => {
        if (shouldLog('debug')) {
            console.log(...formatMessage('DEBUG', args));
        }
    },

    info: (...args: unknown[]): void => {
        if (shouldLog('info')) {
            console.info(...formatMessage('INFO', args));
        }
    },

    warn: (...args: unknown[]): void => {
        if (shouldLog('warn')) {
            console.warn(...formatMessage('WARN', args));
        }
    },

    error: (...args: unknown[]): void => {
        if (shouldLog('error')) {
            console.error(...formatMessage('ERROR', args));
        }
    },

    // Configure the logger
    setEnabled: (enabled: boolean): void => {
        config.enabled = enabled;
    },

    setLevel: (level: LogLevel): void => {
        config.level = level;
    },
};

export default logger;
